<template>
  <footer class="py-1 col-start-2 text-center text-sm font-bold">
    <a :href="companyLink()" target="_blank" class="hover:text-blue-600/90 duration-100">
      © {{ company() }}
    </a>
  </footer>
</template>

<script>

import { company, companyLink } from "#constants/companyInfo";

export default {
  name: "HomeFooter",
  methods: {
    companyLink() {
      return companyLink;
    },
    company() {
      return company;
    },
  },
};
</script>